import { createApp } from 'vue';
import { HpsfirManageBaseUI, HpsfirManageBaseUIApp, HpsfirComponentsMap } from 'hpsfir-managebase-ui';
import 'hpsfir-managebase-ui/lib/lib.css';
import './style/global.scss';
import { initApi } from './hooks/useApi';
import NutUI from '@nutui/nutui';

const allComponents: HpsfirComponentsMap = {};
const viewRequireCnt = require.context('./views', true, /index\.vue$/u);
viewRequireCnt.keys().forEach((key) => {
  const keySplits = key.split('/');
  const dirname = keySplits[keySplits.length - 2];
  console.log(dirname);
  allComponents[dirname!] = () => viewRequireCnt(key).default || viewRequireCnt(key);
});

const ADMIN_SITE_NAME = '驿芯云';

const installMobileTitle = () => {
  let syncFrame = 0;

  const getPageTitle = () => {
    const rawTitle = document.title.trim();
    const siteSuffix = ` - ${ADMIN_SITE_NAME}`;
    const pageTitle = rawTitle.endsWith(siteSuffix)
      ? rawTitle.slice(0, -siteSuffix.length).trim()
      : rawTitle;
    return pageTitle || '管理后台';
  };

  const syncTitle = () => {
    window.cancelAnimationFrame(syncFrame);
    syncFrame = window.requestAnimationFrame(() => {
      const topbar = document.querySelector<HTMLElement>('.ultra-topbar');
      if (!topbar) {
        return;
      }

      let titleEl = topbar.querySelector<HTMLElement>('.ultra-topbar__mobile-title');
      if (!titleEl) {
        titleEl = document.createElement('div');
        titleEl.className = 'ultra-topbar__mobile-title';
        topbar.insertBefore(titleEl, topbar.querySelector('.ultra-topbar__right'));
      }

      const pageTitle = getPageTitle();
      titleEl.textContent = pageTitle;
      titleEl.title = pageTitle;
    });
  };

  const appEl = document.querySelector('#app');
  const appObserver = new MutationObserver(syncTitle);
  if (appEl) {
    appObserver.observe(appEl, { childList: true, subtree: true });
  }

  const titleEl = document.querySelector('title');
  const titleObserver = new MutationObserver(syncTitle);
  if (titleEl) {
    titleObserver.observe(titleEl, { childList: true });
  }

  syncTitle();
};

initApi('/api');

const app = createApp(HpsfirManageBaseUIApp)
  .use(HpsfirManageBaseUI, {
    siteName: ADMIN_SITE_NAME,
    baseApiPath: '/api',
    viewMap: allComponents,
    description: '管理后台',
    logo: '/logo.png',
    theme: 'ultra',
    titleAlwaysShowSiteName: false,
  })
  .use(NutUI);

app.mount('#app');
installMobileTitle();

